export default "__VITE_ASSET__ckLX8cTx__"